// extracted by mini-css-extract-plugin
export default {"workRightAddMenu_cancel_Users":"workRightUsersAddGroup_workRightAddMenu_cancel_Users__Yj1NF"};